module.exports = __webpack_public_path__ + "0ffc390e4a6cc11f399c077ec723bb01.pdf";